import { Injectable } from '@angular/core';
import { Event, NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})

export class NavService {

  public homeAppDrawer: any;
  public appDrawer: any;
  public sideNavEnd: any;
  public currentUrl = new BehaviorSubject<string>(undefined!);

  constructor(
    private router: Router,
    private http: HttpClient
  ) {
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        this.currentUrl.next(event.urlAfterRedirects);
      }
    });
  }

  public closeHomeNav() {
    this.homeAppDrawer?.close();
  }

  public openHomeNav() {
    this.homeAppDrawer.open();
  }

  public closeNav() {
    this.appDrawer?.close();
  }

  public openNav() {
    this.appDrawer.open();
  }

  public closeEndNav() {
    this.sideNavEnd?.close();
  }

  public openEndNav() {
    this.sideNavEnd.open();
  }

  listMenu() {
    return this.http.get(`${environment.baseUrl}/menu/v1/get-menu/`);
  }

  listParentMenu(id) {
    return this.http.get(`${environment.baseUrl}/menu/v1/get-parent-menu/${id}`);
  }

  listUserById(id: any) {
    return this.http.get(`${environment.baseUrl}/user/v1/get-user/${id}`);
  }
}
